// extracted by mini-css-extract-plugin
export default {"errorMessage":"createProject_errorMessage__9e6mi","inputError":"createProject_inputError__JeRvh"};